<template>
	<!-- 电池包-电池list-->
	<div class="batteryOuter">

		<!-- <div
			class="point">
			<div class="inner flex align-center flex-direction">
				<div class="close pointer"></div>
				<div class="title text-xsss margin-top-13 padding-bottom-8">当前编号:#{{ index | formatterNum }}</div>
				<div class="title text-12 padding-bottom-8">当前电压:{{ atItem.st || '' }}</div>
				<div class="code text-12">当前温度:{{ atItem.sv || '' }}</div>
			</div>
		</div> -->
		<div class="batteryCom">
			<div
				class="margin-top-sm batteryBagOuter"
				v-for="(item, index) in batteryBagList"
				:key="index"
				:class="index == curIndex ? 'select' : ''"
				@click="clickIndex(item, index)">
				<div
					class="battery-color flex flex-direction justify-center"
					:class="{'battery-red': item.st >=65 && item.sv >= 4,
							'battery-redTem':item.st >= 65 && item.sv < 4,
							'battery-redVol':item.sv >= 4 && item.st < 65}">
					<div class="text-14 margin-left-15">
						#{{index | formatterNum}}
					</div>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
import { dataInterface } from '@/api/dataInterfaceApi'
export default {
	data() {
		return {
			batteryHolder: [],
			curIndex: 0, //当前选中电池下标,定义新的变量，防止修改父组件
			batteryBagList: [],
			atItem: {}
		};
	},
	components: {},
	// inject: ['batteryId'],
    inject: ['batteryObj'],
    computed: {
        computedProperty() {
            return this.batteryObj()
        }
    },
    watch: {
        computedProperty(val) {
            this.batteryId = val.value
		    this.init()
        },
    },
	// props: {
	// 	batteryData: {
	// 		type: Object,
	// 		default: () => { return {} },
	// 	},
	// },
	// watch: {
	// 	batterySingleData(newV) {
	// 		debugger
	// 		this.batterySingleData = newV
	// 		this.setBatteryPackageList()
	// 	}
	// },
	mounted() {
		// this.setBatteryPackageList()
	},
	methods: {
		init() {
			this.setBatteryPackageList()
		},
		// 点击单个电池
		clickIndex(item, index) {
			if (index != this.curIndex) {
				this.curIndex = index
				this.atItem = item
				this.$emit('changeTem', item)
			}
		},
        // 电池单体信息
		setBatteryPackageList(data) {
			let _this = this
			let params = {
				"enCode": "TiDB-Energy-dianchixiang-dianchidantixinxi",
				"@battery_id": _this.batteryId
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if(!res || !res.length) return
					let data = res[0] || {}
					let st = data.st.split("|")
					let stList = st.slice(2, st.length)
					let sv = data.sv.split("|")
					let scList = sv.slice(2, sv.length)
					_this.batteryBagList = [...scList].map((item, index) => {
						return {
							sv: item,
							st: parseFloat(stList[index]).toFixed(2) || 0,
						}
					})

					this.atItem = _this.batteryBagList[_this.curIndex]
					this.$emit('changeTem', this.atItem)
				})
			.catch((err) => {
				console.log(err);
			})
		},
	},
	filters: {
		// 格式化数据
		formatterNum(data) {
			return data < 9 ? "0" + (data + 1) : data + 1;
		},
	},
}
</script>
<style lang="scss" scoped>

	.batteryOuter {
		margin-top: 10%;
		height: 300px;
		overflow-y: scroll;
		position: relative;

		.batteryBagOuter {
			position: relative;
			cursor: pointer;

			&.select {
				.batteryImg {
					background: url("~@/assets/images/battery/battery_box_select.png");
					background-size: 100% 100%;
				}

			}
		}


		.point {
			display: block;
			position: absolute;
			width: 165px;
			height: 79px;
			background-image: url("~@/assets/images/batteryBag/bg.png");
			background-size: cover;
			top: 30%;
			right: 40%;
			z-index: 100;
			.inner {
				position: relative;
				width: 184px;
				height: 91px;

				.close {
					position: absolute;
					width: 22px;
					height: 22px;
					background-image: url("~@/assets/images/batteryBag/close.png");
					background-size: cover;
					top: 10px;
					right: 10px;
				}
			}
		}
	}


	.batteryCom {
		display: grid;
		grid-template-columns: repeat(10, 81px);
		grid-template-rows: repeat(3, 40px);
		grid-row-gap: 29px;
		grid-column-gap: 7px;
		justify-content: center;
	}

	.battery-color {
		// 单体：默认正常
		width: 81px;
		height: 40px;
		background: url("~@/assets/images/batteryBag/battery_norm.png") no-repeat;
		background-size: 100% 100%;
		position: relative;

		&.battery-red {
			//电压，温度均不正常
			background: url("~@/assets/images/batteryBag/battery_error2.png") no-repeat;
			background-size: 100% 100%;
		}

		&.battery-redTem {
			//温度，不正常
			background: url("~@/assets/images/batteryBag/battery_error1.png") no-repeat;
			background-size: 100% 100%;
		}

		&.battery-redVol {
			//电压，不正常
			background: url("~@/assets/images/batteryBag/battery_error.png") no-repeat;
			background-size: 100% 100%;
		}
	}
</style>
